module.exports = __webpack_public_path__ + "static/richardmille-e5e190f7c56a72a75c8ff02d6d97c730.png";